import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, download, errMsg, fmtNum } from "@/lib/api";
import { PageHeader } from "@/components/common";

export default function CodeChanges() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [moved, setMoved] = useState(true);
  useEffect(() => { api.get("/code-events", { params: { upload_id: id, moved_only: moved } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))); }, [id, moved]);
  return (
    <div className="max-w-6xl" data-testid="code-changes-page">
      <PageHeader title="Code changes" subtitle={d ? `${d.upload.filename} · ${fmtNum(d.moved)} products changed scope${d.upload.alert_sent_to != null ? ` · alert sent to ${d.upload.alert_sent_to}` : ""}` : "Loading…"}>
        <Button variant="outline" size="sm" onClick={() => setMoved(!moved)} data-testid="code-changes-toggle">{moved ? "Show all code changes" : "Scope changes only"}</Button>
        <Button variant="outline" size="sm" onClick={() => download(`/code-events.xlsx?upload_id=${id}`, `code_changes_${id}.xlsx`)} data-testid="code-changes-xlsx"><FileSpreadsheet className="mr-1.5 h-3.5 w-3.5" />Download Excel</Button>
      </PageHeader>
      {d && (
        <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
          <table className="w-full text-sm" data-testid="code-changes-table">
            <thead className="bg-slate-50 text-left text-[11px] uppercase tracking-wider text-slate-500">
              <tr>{["Material", "Plant", "Description", "Code (old → new)", "Scope (before → after)", "In stock", "Event"].map((h) => <th key={h} className="px-3 py-2">{h}</th>)}</tr>
            </thead>
            <tbody>
              {d.items.map((e, i) => (
                <tr key={i} className={`border-t border-slate-100 ${e.stock_qty > 0 ? "bg-amber-50/60" : ""}`} data-testid={`code-changes-row-${i}`}>
                  <td className="px-3 py-1.5 font-mono">{e.material}</td><td className="px-3 py-1.5">{e.plant}</td><td className="px-3 py-1.5">{e.description}</td>
                  <td className="px-3 py-1.5 font-mono text-xs">{e.old_code || "—"} → {e.new_code || "—"}</td>
                  <td className="px-3 py-1.5 font-medium">{e.scope_before_label || "—"} → {e.scope_after_label || "—"}</td>
                  <td className="px-3 py-1.5 text-right font-mono">{fmtNum(e.stock_qty)}</td><td className="px-3 py-1.5 text-xs text-slate-500">{e.label}</td>
                </tr>
              ))}
              {!d.items.length && <tr><td colSpan={7} className="px-3 py-6 text-center text-slate-400">No changes</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
